import { saveAs } from 'file-saver';

export const generateVCard = (profile) => {
  let vcard = 'BEGIN:VCARD\n';
  vcard += 'VERSION:3.0\n';
  vcard += `FN:${profile.firstName} ${profile.lastName}\n`;
  vcard += `N:${profile.lastName};${profile.firstName};;;\n`;
  
  if (profile.company) vcard += `ORG:${profile.company}\n`;
  if (profile.title) vcard += `TITLE:${profile.title}\n`;
  if (profile.phone) vcard += `TEL;TYPE=CELL:${profile.phone}\n`;
  if (profile.email) vcard += `EMAIL:${profile.email}\n`;
  if (profile.website) vcard += `URL:${profile.website}\n`;
  if (profile.address) vcard += `ADR;TYPE=WORK:;;${profile.address};;;;\n`;
  
  // Ajouter les réseaux sociaux comme notes
  let socialNote = '';
  if (profile.socials) {
    if (profile.socials.linkedin) socialNote += `LinkedIn: ${profile.socials.linkedin}\n`;
    if (profile.socials.twitter) socialNote += `Twitter: ${profile.socials.twitter}\n`;
    if (profile.socials.instagram) socialNote += `Instagram: ${profile.socials.instagram}\n`;
    if (profile.socials.facebook) socialNote += `Facebook: ${profile.socials.facebook}\n`;
    if (profile.socials.youtube) socialNote += `YouTube: ${profile.socials.youtube}\n`;
    if (profile.socials.skype) socialNote += `Skype: ${profile.socials.skype}\n`;
    if (profile.socials.whatsapp) socialNote += `WhatsApp: ${profile.socials.whatsapp}\n`;
    if (profile.socials.other) socialNote += `Autre: ${profile.socials.other}\n`;
  }
  
  // Ajouter la note générale et les réseaux sociaux comme note
  let finalNote = '';
  if (profile.note) finalNote += profile.note;
  if (socialNote) {
    if (finalNote) finalNote += '\n\n';
    finalNote += 'Réseaux sociaux:\n' + socialNote;
  }
  
  if (finalNote) vcard += `NOTE:${finalNote}\n`;
  
  // Ajouter des URL pour les réseaux sociaux les plus courants
  if (profile.socials) {
    if (profile.socials.linkedin && profile.socials.linkedin.startsWith('http')) {
      vcard += `URL;type=LINKEDIN:${profile.socials.linkedin}\n`;
    }
    
    if (profile.socials.twitter && !profile.socials.twitter.startsWith('http')) {
      vcard += `URL;type=TWITTER:https://twitter.com/${profile.socials.twitter.replace('@', '')}\n`;
    }
    
    if (profile.socials.facebook && profile.socials.facebook.startsWith('http')) {
      vcard += `URL;type=FACEBOOK:${profile.socials.facebook}\n`;
    }
    
    if (profile.socials.instagram && !profile.socials.instagram.startsWith('http')) {
      vcard += `URL;type=INSTAGRAM:https://instagram.com/${profile.socials.instagram.replace('@', '')}\n`;
    }
    
    if (profile.socials.youtube && profile.socials.youtube.startsWith('http')) {
      vcard += `URL;type=YOUTUBE:${profile.socials.youtube}\n`;
    }
    
    if (profile.socials.whatsapp && !profile.socials.whatsapp.startsWith('http')) {
      vcard += `URL;type=WHATSAPP:https://wa.me/${profile.socials.whatsapp.replace(/[^0-9]/g, '')}\n`;
    }
  }
  
  // Ajouter la photo de profil si disponible
  if (profile.photoUrl) {
    // Pour les données en base64 (à partir de FileReader)
    if (profile.photoUrl.startsWith('data:image')) {
      const base64Data = profile.photoUrl.split(',')[1];
      vcard += `PHOTO;ENCODING=b;TYPE=JPEG:${base64Data}\n`;
    } 
    // Pour les URLs externes
    else if (profile.photoUrl.startsWith('http')) {
      vcard += `PHOTO;VALUE=URI:${profile.photoUrl}\n`;
    }
  }
  
  // Ajouter le logo de l'entreprise si disponible
  if (profile.companyLogo) {
    // Pour les données en base64 (à partir de FileReader)
    if (profile.companyLogo.startsWith('data:image')) {
      const base64Data = profile.companyLogo.split(',')[1];
      vcard += `LOGO;ENCODING=b;TYPE=JPEG:${base64Data}\n`;
    } 
    // Pour les URLs externes
    else if (profile.companyLogo.startsWith('http')) {
      vcard += `LOGO;VALUE=URI:${profile.companyLogo}\n`;
    }
  }
  
  vcard += 'END:VCARD';
  
  // Créer et télécharger le fichier
  const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
  saveAs(blob, `${profile.firstName.toLowerCase()}_${profile.lastName.toLowerCase()}.vcf`);
};
